import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { IStoreState } from "../../../../reducers/types";
import {
  getPackagesAvailabilityStayDates,
  getPackagesByLodgingId,
  getPackageNightCountBasedOnAvailability,
  getTravelersCount,
} from "../../../availability/reducer";
import {
  getRewardsAccountWithLargestEarnForBanner,
  getSelectedAccountReferenceIdIfRedemptionEnabled,
} from "../../../rewards/reducer";
import {
  getAdultsCount,
  getChildren,
  getDepartureDate,
  getFareclassOptionFilter,
  getInfants,
  getOrigin,
  getReturnDate,
  getStopsOption,
} from "../../../search/reducer";
import { PackageHotelShopCallState } from "../../reducer/state";
import {
  getCheapestLodgingRoomProduct,
  getHotelShopCallState,
  getHotelShopCancellationSummary,
  getHotelShopChosenProduct,
  getPackageRatesById,
  getPackageSelectedLodging,
  getSearchDistanceFromShopProperties,
  hasHotelShopFailed,
  hotelShopProgressSelector,
  showOfferBasedOnSelectedLodgingSelector,
} from "../../reducer/selectors";
import { MobileShop } from "./component";
import { setPackageHotelShopProgress } from "../../actions/actions";

const mapStateToProps = (state: IStoreState) => {
  return {
    lodging: getPackageSelectedLodging(state),
    cheapestProduct: getCheapestLodgingRoomProduct(state),
    hotelShopCallInProgress:
      getHotelShopCallState(state) === PackageHotelShopCallState.InProcess,
    chosenProduct: getHotelShopChosenProduct(state),
    hasFailed: hasHotelShopFailed(state),
    hotelShopStep: hotelShopProgressSelector(state),
    stayDates: getPackagesAvailabilityStayDates(state),
    fromDate: getDepartureDate(state),
    untilDate: getReturnDate(state),
    largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
    adultsCount: getAdultsCount(state),
    children: getChildren(state),
    hotelShopCallState: getHotelShopCallState(state),
    nightCount: getPackageNightCountBasedOnAvailability(state),
    rewardsKey: getSelectedAccountReferenceIdIfRedemptionEnabled(state),
    packagesByRateId: getPackageRatesById(state),
    travelersCount: getTravelersCount(state),
    cancellationSummary: getHotelShopCancellationSummary(state),
    origin: getOrigin(state),
    infants: getInfants(state),
    stopsOption: getStopsOption(state),
    fareClassOptionFilter: getFareclassOptionFilter(state),
    searchDistanceFromShopProperties:
      getSearchDistanceFromShopProperties(state),
    packagesByLodgingId: getPackagesByLodgingId(state),
    showOfferBasedOnSelectedLodging:
      showOfferBasedOnSelectedLodgingSelector(state),
  };
};

export const mapDispatchToProps = {
  setPackageHotelShopProgress,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileShopConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedMobileShop = withRouter(connector(MobileShop));
